module.exports = __webpack_public_path__ + "img/startplay.e1c7ddd1.png";